<script lang="ts">
	import './notification.component.css';
	import { NotificationEnum } from '../../interfaces/Notification';
	import { _ } from '../../utility-services/Translation.service';

	interface Props {
		title?: string;
		type?: NotificationEnum;
		description?: string;
		duration?: number;
		show?: boolean;
	}

	let {
		title = '',
		type = NotificationEnum.Info,
		description = '',
		duration = 5000,
		show = $bindable(false)
	}: Props = $props();

	let notificationTimer: ReturnType<typeof setTimeout>;

	$effect(() => {
		if (show) {
			clearTimeout(notificationTimer);
			notificationTimer = setTimeout(() => {
				closeNotification();
			}, duration);
		}

		return () => {
			clearTimeout(notificationTimer);
		};
	});

	function closeNotification() {
		show = false;
	}
</script>

<div>
	{#if show}
		<div
			class="vtmn-fixed vtmn-top-7 vtmn-right-7 vtmn-max-w-md index vtmn-z-50"
			role="alert"
			aria-live="assertive"
		>
			<div
				class="vtmn-alert vtmn-alert_variant--{type} vtmn-min-w-full vtmn-max-h-full"
				aria-labelledby="alert-title-1"
				aria-describedby="alert-text-1"
			>
				<div class="vtmn-alert_content vtmn-overflow-hidden" role="document">
					<div id="alert-title-1" class="vtmn-alert_content-title">
						{title}
						<button
							onclick={closeNotification}
							class="vtmn-btn vtmn-btn_variant--ghost-reversed vtmn-btn_size--small vtmn-btn--icon-alone"
						>
							<span class="vtmn-sr-only">{$_('close_alert')}</span>
							<span class="vtmx-close-line" aria-hidden="true"></span>
						</button>
					</div>
					<p id="alert-text-1" class="vtmn-break-words notification_description">
						{description}
					</p>
				</div>
			</div>
		</div>
	{/if}
</div>
